import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { ChangeNamePopupComponent } from '../change-name-popup/change-name-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DragStore } from 'src/app/store/drag-store';

@Component({
    selector: 'que-step-actions',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './step-actions.component.html',
    styleUrls: ['./step-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepActionsComponent {
  @Input() index!: number;
  @Input() stepName?:string;
  @Output() closeMenuStepEvent = new EventEmitter();
  #dialog = inject(MatDialog)
  #questionnaireStore = inject(QuestionnaireStore);
  #dragStore = inject(DragStore);

  numOfStep$=this.#questionnaireStore.steps$.pipe(map(steps=>steps.length));

  changeName() {
     this.closeMenuStepEvent.emit()
    this.#dialog.open(ChangeNamePopupComponent,
      {
        data: { name: this.stepName, index: this.index },
        autoFocus: false,
        // position: { top: '1.6%', right: '17%' }
      }
    ).afterClosed().subscribe(
      (name) => {
        if (name) {
           this.#questionnaireStore.updateStepName({ name, index: this.index })
        }
      }
    )
  }
  duplicate() {
    this.closeMenuStepEvent.emit();
    this.#dragStore.duplicateStep(this.index);
  }
  delete() {
    this.closeMenuStepEvent.emit();
    this.#questionnaireStore.DeleteStep(this.index)
  }
  move(direction: string) {
    this.closeMenuStepEvent.emit();
    if (direction == 't') {
      this.#questionnaireStore.MoveStepTop(this.index);
    }
    else {
      this.#questionnaireStore.MoveStepBottom(this.index);
    }
  }
}
